export default "__VITE_ASSET__19SzWuou__"